import React from 'react';
import { ReduxState } from 'interface';
import { connect } from 'react-redux';
import './formCard.stylton.scss';
const FormCardSkeleton: React.FC = function () {
    return (
        <div className="ucheck-kiosk-panel-form-card-skeleton">
            <div className="pic ucheck-skeleton" />
            <div className="info">
                <div
                    style={{
                        width: (20 + Math.random() * 80).toString() + '%',
                    }}
                    className="items ucheck-skeleton"
                />
                <div
                    style={{
                        width: (20 + Math.random() * 80).toString() + '%',
                    }}
                    className="items ucheck-skeleton"
                />
                <div
                    style={{
                        width: (20 + Math.random() * 80).toString() + '%',
                    }}
                    className="items ucheck-skeleton"
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    language: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(FormCardSkeleton);
